module.exports = __webpack_public_path__ + "img/SensorAssign.18cd0782.svg";